




import {Component, Prop} from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue';
import ConversationStatus from '@/models/Conversations/ConversationStatus';
import StatusDisplayLocation from '@/models/Shared/StatusDisplayLocation';


@Component({
  name: 'ConversationStatus',
})
export default class extends GiganautVue {

	@Prop({required: true})
	status: ConversationStatus;

	@Prop({required: true})
	location: StatusDisplayLocation;
	
	get textColor() {
		let color = "grey--text";
		switch (this.status) {
			case ConversationStatus.WorkerCreated:
			case ConversationStatus.WorkerWaiting:
				color = "red--text";
				break;
			case ConversationStatus.AgencyUserCreated:
			case ConversationStatus.AgencyUserWaiting:
				color = "green--text";
				break;
			case ConversationStatus.NoActionRequired:
			case ConversationStatus.Inactive:
			case ConversationStatus.Archived:
			default:
				color = "grey-text";
				break;
		}
		return color;
	}

	get text() {
		let text = "";
		switch (this.status) {
			case ConversationStatus.AgencyUserCreated:
				text = "NEW";
				break;
			case ConversationStatus.WorkerCreated:
				text = "NEW";
				break;
			case ConversationStatus.WorkerWaiting:
				text = "WORKER WAITING";
				break;
			case ConversationStatus.AgencyUserWaiting:
				text = "AGENCY WAITING";
				break;
			case ConversationStatus.NoActionRequired:
				text = "NO ACTION REQUIRED";
				break;
			case ConversationStatus.Inactive:
				text = "INACTIVE";
				break;
			case ConversationStatus.Archived:
				text = "ARCHIVED";
				break;
			default:
				text = "UNKNOWN STATUS"
				break;
		}
		return text;
	}
	
	get classy() {
		const classes: string[] = [this.textColor]
		switch (this.location) {
			case StatusDisplayLocation.Title:
				classes.push("overline");
				classes.push("ma-2");
				break;
			case StatusDisplayLocation.Grid:
				classes.push("caption");
				break;
			case StatusDisplayLocation.SubTitle:
			default:
				classes.push("overline");
				classes.push("ma-2");
				break;
		}
		return classes;
	}
}
